import { render, staticRenderFns } from "./downPerson.vue?vue&type=template&id=433c4ffc&scoped=true&"
import script from "./downPerson.vue?vue&type=script&lang=js&"
export * from "./downPerson.vue?vue&type=script&lang=js&"
import style0 from "./downPerson.vue?vue&type=style&index=0&id=433c4ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433c4ffc",
  null
  
)

export default component.exports